import { useSelector } from 'react-redux';
import type Context from '@alltrails/core/types/Context';
import type { User } from '@alltrails/types/User';

const useUser = (): User | null => {
  return useSelector((state: { context: Context }) => state.context.currentUser) || null;
};

export default useUser;
